<div class="container">
    <div class="row mb-3">
        <div class="col section-title-full">
            <h1>
                <span i18n>Ficha del vehículo</span>
            </h1>
        </div>
    </div>
</div>

<div class="container">
    <div class="row" *ngIf="vehicle">
        <div class="col-12">
            <button type="button" class="btn btn-outline-primary btn-rounded" (click)="goBack()" i18n>Volver</button>
        </div>
        <div class="col-md-6 col-lg-5">
            <div class="d-flex align-items-center">
                <img [src]="'data:image/svg+xml;base64,'+vehicle.iconLabel" *ngIf="vehicle.iconLabel" alt="etiqueta ambiental" class="svg-icon-label" />
                <i class="bi bi-car-front vehicle-icon" *ngIf="!vehicle || !vehicle.iconCategory"></i>
                <img [src]="'data:image/svg+xml;base64,'+vehicle.iconCategory" *ngIf="vehicle && vehicle.iconCategory" alt="categoria vehiculo" class="svg-icon" />
                <div>
                    <p class="vehicle-plate">{{vehicle.vehiclePlate}}</p>
                    <!-- <span class="vehicle-type">{{vehicle.type.name}}</span> -->
                    <span class="vehicle-type">{{vehicle.vehicleAlias}}</span>
                </div>
            </div>
        </div>

        <div class="col-md-6 col-lg-7 btn-actions text-md-end">
            <button type="button" class="btn btn-outline-secondary mb-2 btn-rounded" (click)="goToEditVehicle()"i18n>Modificar datos</button>
            <button type="button" class="btn btn-primary mb-2 btn-rounded" (click)="deleteVehicle()" i18n>Eliminar vehículo</button>
        </div>
    </div>

    <hr>

    <div class="row align-items-center">
        <div class="col-md-8">
            <h2 class="my-4" i18n>Listado de solicitudes y autorizaciones</h2>
        </div>

        <div class="col-md-4 text-md-end">
            <button type="button" class="btn btn-primary btn-rounded" (click)="newAutorization()">Nueva autorización</button>
        </div>

        <div class="col-12">
            <div class="card">
                <div class="table-responsive">
                    <table class="table clickable">
                        <thead>
                            <tr>
                                <th class="text-center" scope="col" i18n>Fecha Creación</th>
                                <th class="text-center" scope="col" i18n>Fecha Modificación</th>
                                <th class="text-center" scope="col" i18n>Estado</th>
                                <th class="text-center" scope="col" i18n>Población</th>
                                <th class="text-center" scope="col" i18n>Notificaciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr (click)="goToEditException(exception.exceptionIdentifier)"
                                *ngFor="let exception of exceptionsList">
                                <td class="text-center">{{exception.timestamps.creationTimestamp.timestamp | date:
                                    'dd/MM/yyyy HH:mm:ss'}}</td>
                                <td class="text-center">{{exception.timestamps.modificationTimestamp.timestamp| date:
                                    'dd/MM/yyyy HH:mm:ss'}}</td>
                                <td class="text-center"><app-status-tag [status]="exception.state"></app-status-tag>
                                </td>
                                <td class="text-center">{{exception.municipalities}}</td>
                                <td class="text-center">{{exception.states.length}}</td>
                            </tr>
                            <span *ngIf="exceptionsList.length == 0" i18n>Sin solicitudes</span>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h2 class="mt-5" i18n>Accesos por municipio</h2>
            <p class="text-destacado mb-4" i18n>El número de accesos por vehículo está limitado a 10 por municipio.</p>
            <div class="card" *ngIf="municipalities.length === muniAccesses.length">
                <div *ngFor="let muni of muniAccesses">
                    <h4 i18n>{{muni.name}}</h4>
                    <div class="progress mb-3" role="progressbar" aria-label="Success example" aria-valuenow="25"
                        aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" [ngClass]="muni.class" [style]="muni.percentaje">{{muni.total}} /
                            {{totalAccesses}}</div>
                    </div>
                </div>
            </div>
            <div class="card" *ngIf="municipalities.length != muniAccesses.length">
                <p i18n>Esperando datos...</p>
            </div>
        </div>
    </div>

    <!-- <div class="row">
        <div class="col-12">
            <h2 class="mt-5 mb-4" i18n>Histórico de accesos</h2>

            <div class="card">
                <div class="d-flex access-list" *ngIf="accessList">
                    <div class="access" [ngClass]="access.state" *ngFor="let access of accessList">
                        <div>
                            <i class="bi bi-geo-alt"></i>
                            <p>{{access.state}}</p>
                            <p><span>{{access.timestamp.timestamp | date:'dd/MM/yyyy'}}</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="row mb-5">
        <div class="col-12">
            <h2 class="mt-5 mb-4" i18n>Otros vehículos</h2>

            <div class="row" *ngIf="vehicles">
                <div class="col-sm-6 col-md-4 mb-3" (click)="goToViewVehicle(vehicle.vehiclePlate)"
                    *ngFor="let vehicle of vehicles">
                    <app-vehicle-iccon-resume [vehicle]="vehicle"></app-vehicle-iccon-resume>
                </div>
                <div class="col-sm-6 col-md-4 mb-3" (click)="newVehicle()">
                    <app-vehicle-iccon-resume></app-vehicle-iccon-resume>
                </div>
            </div>
        </div>
    </div>


</div>